"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_InputProps = exports["default"] = exports.Input = exports.RawInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormBaseWrapper = _interopRequireDefault(require("../FormBaseWrapper"));

var _ThemeProvider = require("../../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _passwordNofill = _interopRequireDefault(require("./password-nofill"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var bpfrpt_proptype_InputProps = {
  "id": _propTypes["default"].string,
  "value": _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  "name": _propTypes["default"].string,
  "handleChange": _propTypes["default"].func.isRequired,
  "type": _propTypes["default"].string,
  "className": _propTypes["default"].string,
  "italic": _propTypes["default"].bool,
  "classes": _propTypes["default"].shape({
    Input: _propTypes["default"].string.isRequired,
    Italic: _propTypes["default"].string.isRequired
  }).isRequired,
  "autoComplete": _propTypes["default"].bool
};
exports.bpfrpt_proptype_InputProps = bpfrpt_proptype_InputProps;

var Input = function Input(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      handleChange = _ref.handleChange,
      _ref$italic = _ref.italic,
      italic = _ref$italic === void 0 ? true : _ref$italic,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "className", "handleChange", "italic"]);

  // $FlowIgnore
  if (props.type === 'password' && props.autoComplete === false && !!document.fonts) {
    return /*#__PURE__*/React.createElement(_passwordNofill["default"], (0, _extends2["default"])({}, props, {
      "data-ctrl-name": props.id,
      onChange: handleChange,
      className: (0, _classnames["default"])(className, italic && classes.Italic)
    }));
  }

  return /*#__PURE__*/React.createElement(_FormControl["default"], (0, _extends2["default"])({}, props, {
    "data-ctrl-name": props.id,
    onChange: handleChange,
    className: (0, _classnames["default"])(className, classes.Input, italic && classes.Italic)
  }));
};

Input.propTypes = bpfrpt_proptype_InputProps;
var ThemedInput = (0, _ThemeProvider.withStyles)(_style["default"])(Input);
exports.Input = exports.RawInput = ThemedInput;

var StiloInput = function StiloInput(props) {
  return /*#__PURE__*/React.createElement(_FormBaseWrapper["default"], (0, _extends2["default"])({}, props, {
    Control: ThemedInput
  }));
};

exports["default"] = StiloInput;
//# sourceMappingURL=bootstrap.js.map